import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function getPurchaseEntries(teamUuid) {
    try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        if (!baseUrl) {
            throw new Error('API base URL is not configured');
        }

        const token = getToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        if (!teamUuid) {
            throw new Error('Team UUID is required');
        }

        const url = `${baseUrl}/purchase-entries`;

        return axios.get(url, {
            params: { team_uuid: teamUuid },
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            timeout: 30000 // 30 second timeout
        });
    } catch (error) {
        return Promise.reject(error);
    }
}
